<script>
import MapLegend from "@/components/MapLegend.vue";

export default {
  name: "MapLegendContainer",
  components: {MapLegend},
  data() {
    return {
      legendVisible: true
    }
  },
  methods: {
    updateVarItem(varItem) {
      this.$refs.legend.updateVarItem(varItem)
    },
    updateLegend(title, subTitle, colors) {
      this.$refs.legend.updateLegend(title, subTitle, colors)
    }
  }
}
</script>

<template>
  <div class="map-legend-container">
    <map-legend v-show="legendVisible" ref="legend"></map-legend>
    <a v-if="legendVisible" @click="legendVisible = false" href="#">Hide</a>
    <a v-if="!legendVisible" href="#" @click="legendVisible = true">Show legend</a>
  </div>
</template>

<style scoped>

</style>